import { lazy } from "react";
import ProtectedRoute from "./ProtectedRoute";
import { Navigate } from "react-router-dom";
import RolesPermission from "../Pages/IAM/Roles/RolesPermission";
import StatusFail from "../Components/Common/StatusFail";
 

// Lazy loading components
const Dashboard = lazy(() => import("../Pages/Dashboard/Dashboard"));
const Workflows = lazy(() => import("../Pages/WorkSpace/Workflows/Workflows"));
const Workforms = lazy(() => import("../Pages/WorkSpace/Workforms/Workforms"));
const Workstates = lazy(() =>
  import("../Pages/WorkSpace/Workstates/Workstates")
);
const Roles = lazy(() => import("../Pages/IAM/Roles/Roles"));
const Groups = lazy(() => import("../Pages/IAM/Groups/Groups"));
const Ward = lazy(() => import("../Pages/Providers/Ward/Ward"));
const Agreements = lazy(() =>
  import("../Pages/Providers/Agreements/Agreements")
);
const Patients = lazy(() => import("../Pages/Patients/Patients"));
const Roster = lazy(() => import("../Pages/Apps/Practitioner/Roster/Roster"));
const Studio = lazy(() => import("../Pages/Apps/Studio/Studio"));
const Admin = lazy(() => import("../Pages/Apps/Admin/Admin"));
const Trust = lazy(() => import("../Pages/Trust/Trust"));
const Support = lazy(() => import("../Pages/Support/Support"));
const Departments = lazy(() =>
  import("../Pages/General/Departments/Departments")
);
const Services = lazy(() => import("../Pages/General/Services/Services"));
const PatnersAgreement = lazy(() => import("../Pages/Patners/Agreement/Agreement"));
const Billing = lazy(() => import("../Pages/Billing/Billing"));
const OpdBoard = lazy(() => import("../Pages/Operations/OpdBoard"));
const IpdBoard = lazy(() => import("../Pages/Operations/IpdBoard"));
const Finance = lazy(() => import("../Pages/Finance/Finance"));
const Subscription = lazy(() => import("../Pages/Subscription/Subscription"));
const Tariff = lazy(() => import("../Pages/General/Tariff/Tariff"));
const Diagnostic = lazy(() => import("../Pages/General/Diagnostic/Diagnostic"));
const AddDiagnostic = lazy(() => import("../Pages/General/Diagnostic/AddDiagnostic"));
const Pharmacy = lazy(() => import("../Pages/General/Pharmacy/Pharmacy"));
const AddPharmacy = lazy(() => import("../Pages/General/Pharmacy/AddPharmacy"));
const Package = lazy(() => import("../Pages/General/Packages/Package"));
const Vitals = lazy(() => import("../Pages/General/Vitals/Vitals"));
const PrescriptionList = lazy(() => import("../Pages/Prescriptions/PrescriptionList"));
const PrescriptionView = lazy(() => import("../Pages/Prescriptions/PrescriptionView"));
const UnauthorizedModal = lazy(() =>
  import("../Components/Common/UnauthorizedModal")
);
const NotFound = lazy(() => import("../Components/Common/NotFound"));
const Practitionerpermisson = lazy(() =>
  import("../Pages/IAM/Roles/Practitionerpermisson")
);
const Notification = lazy(() =>
  import("../Pages/Notification/Notification")
);

const AddPackage = lazy(() =>import("../Pages/General/Packages/AddPackage"));
 
const routes = [
  // Default route
  { path: "/", component: <Navigate to="/dashboard" /> },
  { path: "/dashboard", component: (<ProtectedRoute><Dashboard /></ProtectedRoute>) },
  { path: "/opd", component: (<ProtectedRoute><OpdBoard /></ProtectedRoute>) },
  { path: "/ipd", component: (<ProtectedRoute><IpdBoard /></ProtectedRoute>) },

  // WorkSpace routes
  { path: "/workSpace/workflows", component: (<ProtectedRoute><Workflows /></ProtectedRoute>) },
  { path: "/workSpace/workforms", component: (<ProtectedRoute><Workforms /></ProtectedRoute>) },
  { path: "/workSpace/workstates", component: (<ProtectedRoute><Workstates /></ProtectedRoute>) },

  // IAM routes
  { path: "/iam/roles", component: (<ProtectedRoute><Roles /></ProtectedRoute>) },
  { path: "/iam/groups", component: (<ProtectedRoute><Groups /></ProtectedRoute>) },
  { path: "/iam/roles/practitionerpermisson", component: (<ProtectedRoute><Practitionerpermisson /></ProtectedRoute>) },
  { path: "/iam/roles/adminPermission", component: (<ProtectedRoute><RolesPermission /></ProtectedRoute>) },

  // Providers routes
  { path: "/providers/agreements", component: (<ProtectedRoute><Agreements /></ProtectedRoute>) },
  { path: "/providers/ward", component: (<ProtectedRoute><Ward /></ProtectedRoute>) },

  // Partners routes
  { path: "/partners/agreement", component: (<ProtectedRoute><PatnersAgreement /></ProtectedRoute>) },

  // Patients route
  { path: "/patients", component: (<ProtectedRoute><Patients /></ProtectedRoute>) },

  // Apps routes
  { path: "/apps/practitioner/roster", component: (<ProtectedRoute><Roster /></ProtectedRoute>) },
  { path: "/apps/studio", component: (<ProtectedRoute><Studio /></ProtectedRoute>) },
  { path: "/apps/admin", component: (<ProtectedRoute><Admin /></ProtectedRoute>) },

  // Trust route
  { path: "/trust", component: (<ProtectedRoute><Trust /></ProtectedRoute>) },

  // Billing route
  { path: "/billing", component: (<ProtectedRoute><Billing /></ProtectedRoute>) },
  { path: "/finance", component: (<ProtectedRoute><Finance /></ProtectedRoute>) },
  { path: "/subscription", component: (<ProtectedRoute><Subscription /></ProtectedRoute>) },

  // Support route
  { path: "/support", component: (<ProtectedRoute><Support /></ProtectedRoute>) },
  { path: "/notification", component: (<ProtectedRoute><Notification /></ProtectedRoute>) },

  // General routes
  { path: "/general/departments", component: (<ProtectedRoute><Departments /></ProtectedRoute>) },
  { path: "/general/services", component: (<ProtectedRoute><Services /></ProtectedRoute>) },
  { path: "/general/appointments", component: <Navigate to="/opd" replace /> },
  { path: "/general/tariff", component: (<ProtectedRoute><Tariff /></ProtectedRoute>) },
  { path: "/general/diagnostic", component: (<ProtectedRoute><Diagnostic /></ProtectedRoute>) },
  { path: "/general/add-diagnostic", component: (<ProtectedRoute><AddDiagnostic /></ProtectedRoute>) },
  { path: "/general/add-pharmacy", component: (<ProtectedRoute><AddPharmacy /></ProtectedRoute>) },
  { path: "/general/package", component: (<ProtectedRoute><Package /></ProtectedRoute>) },
  { path: "/general/add-package", component: (<ProtectedRoute><AddPackage /></ProtectedRoute>) },
  { path: "/general/pharmacy", component: (<ProtectedRoute><Pharmacy /></ProtectedRoute>) },
  { path: "/general/vitals", component: (<ProtectedRoute><Vitals /></ProtectedRoute>) },
  { path: "/prescriptions", component: (<ProtectedRoute><PrescriptionList /></ProtectedRoute>) },
  { path: "/prescriptions/:id", component: (<ProtectedRoute><PrescriptionView /></ProtectedRoute>) },

  // Unauthorized route
  { path: "/unauthorized", component: <UnauthorizedModal /> },

  { path: "/status-failed", component: <StatusFail /> },
  
  // Catch-all route
  { path: "*", component: <NotFound /> },
];

export default routes;
